// セッションストレージのユーティリティ関数

const SESSION_CHAT_IDS_KEY = 'sessionChatIds';
export const SESSION_CHAT_IDS_EVENT = 'session-chat-ids-changed';

function notifySessionChatIdsChanged() {
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new CustomEvent(SESSION_CHAT_IDS_EVENT));
  }
}

/**
 * セッションストレージからチャットIDのリストを取得
 */
export function getSessionChatIds(): string[] {
  try {
    const stored = sessionStorage.getItem(SESSION_CHAT_IDS_KEY);
    if (!stored) {
      return [];
    }
    return JSON.parse(stored);
  } catch (error) {
    console.error('[SessionStorage] Failed to get session chat IDs:', error);
    return [];
  }
}

/**
 * セッションストレージにチャットIDを追加
 */
export function addSessionChatId(chatId: string): void {
  try {
    const chatIds = getSessionChatIds();
    if (!chatIds.includes(chatId)) {
      chatIds.push(chatId);
      sessionStorage.setItem(SESSION_CHAT_IDS_KEY, JSON.stringify(chatIds));
      notifySessionChatIdsChanged();
    }
  } catch (error) {
    console.error('[SessionStorage] Failed to add session chat ID:', error);
  }
}

/**
 * セッションストレージからチャットIDを削除
 */
export function removeSessionChatId(chatId: string): void {
  try {
    const chatIds = getSessionChatIds();
    const filtered = chatIds.filter(id => id !== chatId);
    sessionStorage.setItem(SESSION_CHAT_IDS_KEY, JSON.stringify(filtered));
    notifySessionChatIdsChanged();
  } catch (error) {
    console.error('[SessionStorage] Failed to remove session chat ID:', error);
  }
}

/**
 * チャットIDがセッションストレージに存在するかチェック
 */
export function hasSessionChatId(chatId: string): boolean {
  const chatIds = getSessionChatIds();
  return chatIds.includes(chatId);
}

